if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          // activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          // if (this.elements.thumbnails) {
          //   const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          //   activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          // }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          // window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Custom Buttons Navigation
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 899) {

    const leftButton = document.querySelector("#wbc-product-slider-left");
    const rightButton = document.querySelector("#wbc-product-slider-right");
  
    function getThumbnails() {
      const thumbnails = document.querySelectorAll(
        ".product--thumbnail_slider .product__media-wrapper .product__column-sticky .thumbnail-slider .thumbnail-list .thumbnail-list__item"
      );
      return thumbnails;
    }
  
    function findActiveThumbnail() {
      const thumbnails = getThumbnails();
      console.log("Checking thumbnails...");
  
      let activeThumb = null;
      thumbnails.forEach((thumb, index) => {
        const button = thumb.querySelector("button");
        const ariaCurrent = button?.getAttribute("aria-current");
  
        console.log(`Thumbnail ${index}:`, { button, ariaCurrent });
  
        if (ariaCurrent === "true") {
          activeThumb = thumb;
           activeThumb.scrollIntoView({
            behavior: 'smooth', // Optional: adds smooth scroll effect
            block: 'nearest', // Ensures the thumbnail will align with the visible area
          });
        }
      });
  
      console.log("Active Thumbnail Found:", activeThumb);
      return activeThumb;
    }
  
    function updateActiveThumbnail(direction) {
      console.log(`Button clicked: ${direction}`);
  
      let current = findActiveThumbnail();
  
      if (!current) {
        console.warn("No active thumbnail found! Retrying in 100ms...");
        setTimeout(() => {
          current = findActiveThumbnail();
          if (!current) {
            console.error("Still no active thumbnail found. Check if JavaScript is modifying aria-current.");
          } else {
            console.log("Active thumbnail found on retry:", current);
          }
        }, 100);
        return;
      }
  
      const thumbnailsArray = Array.from(getThumbnails());
      const currentIndex = thumbnailsArray.indexOf(current);
      console.log("Current active index:", currentIndex);
  
      if (currentIndex === -1) {
        console.error("Current active thumbnail is not found in the array!");
        return;
      }
  
      let newIndex;
      if (direction === "left") {
        newIndex = currentIndex === 0 ? thumbnailsArray.length - 1 : currentIndex - 1;
      } else {
        newIndex = currentIndex === thumbnailsArray.length - 1 ? 0 : currentIndex + 1;
      }
  
      console.log(`New active index: ${newIndex}`);
  
      // Remove aria-current from the current thumbnail
      const currentButton = current.querySelector("button");
      if (currentButton) {
        currentButton.removeAttribute("aria-current");
        console.log("Removed aria-current from:", current);
      } else {
        console.warn("No button found inside current thumbnail.");
      }
  
      // Set aria-current to the new active thumbnail
      const newButton = thumbnailsArray[newIndex]?.querySelector("button");
      if (newButton) {
        newButton.setAttribute("aria-current", "true");
        console.log("Set aria-current on:", thumbnailsArray[newIndex]);
  
        // Simulate a click on the new active thumbnail
        newButton.click();
      } else {
        console.warn("No button found inside new thumbnail.");
      }
    }
  
    leftButton?.addEventListener("click", () => updateActiveThumbnail("left"));
    rightButton?.addEventListener("click", () => updateActiveThumbnail("right"));
  
    // Watch for changes in aria-current
    const observer = new MutationObserver(() => {
      console.log("MutationObserver detected a change in the DOM!");
      findActiveThumbnail(); // Check if active thumbnail updates correctly
    });
  
    getThumbnails().forEach((thumb) => {
      const button = thumb.querySelector("button");
      if (button) {
        observer.observe(button, { attributes: true, attributeFilter: ["aria-current"] });
      }
    });
  
    // Run findActiveThumbnail on load to debug
    setTimeout(() => findActiveThumbnail(), 500);
  }
});


